module.exports = __webpack_public_path__ + "194568d7590ff5135bc7053f2382ea36.png";